<template>
  <div>
    <!-- Header Container
================================================== -->
    <header id="header-container" class="fullwidth dashboard-header not-sticky">
      <!-- Header -->
      <div id="header">
        <div class="container">
          <!-- Left Side Content -->
          <div class="left-side">
            <!-- Logo -->
            <div id="logo">
              <router-link to="/"
                ><img
                  src="@/assets/images/company-logo-01.png"
                  alt="3hjobs logo"
              /></router-link>
            </div>
            <nav id="navigation">
              <ul id="responsive">
                <li>Welcome {{ loggedInUser.name }}</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <!-- Header / End -->
    </header>
    <div class="clearfix"></div>
    <!-- Header Container / End -->
  </div>
</template>

<script>
export default {
  name: "AppNavbar",
  data: function() {
    return {};
  },

  computed: {
    isLoggedIn() {
      return !!this.$store.state.token;
    },

    loggedInUser() {
      return this.$store.state.userData;
    },
  },
};
</script>

<style></style>
